import { sanitizePhones, addressToRaw } from './formatters';

export const personToRaw = person => ({
  ...person,
  phones: person.phones ? sanitizePhones(person.phones) : [],
  address: person.address ? addressToRaw(person.address) : {},
});
